import { initializeApp } from '@firebase/app';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';
import { displayNotificationInUI } from './utils/DisplayNotification';

const firebaseConfig = {
    apiKey: "AIzaSyB0XFM3qQbWaU2hol76AOGcF8oUOwwe5RA",
    authDomain: "mvrc-app.firebaseapp.com",
    projectId: "mvrc-app",
    storageBucket: "mvrc-app.firebasestorage.app",
    messagingSenderId: "1077050228249",
    appId: "1:1077050228249:web:2e822c8bf92fc5fb6e3488",
    measurementId: "G-3CGMKV84Z9"
};
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const setupNotifications = async () => {
    try {
        // Request permission for notifications
        const permission = await Notification.requestPermission();

        if (permission === 'granted') {
            const token = await getToken(messaging);
        } else {
            console.log('Notification permission denied.');
        }
        // Handle foreground notifications
        onMessage(messaging, (payload) => {
            const { title, body, image } = payload.notification;
            new Notification(title, {
                body: body,
                icon: image || "/logo192.png",
            });
            console.log("Foreground notifiction received: " + title);
            displayNotificationInUI(title, body, image);
        });
    } catch (error) {
        console.error('Error setting up notifications:', error);
    }
};

export { messaging, setupNotifications };